const $$splitComponentImporter = () => import('/Users/lois/Documents/GitHub/zephyr/repos/storage-viewer/src/routes/keys.$namespaceId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createFileRoute('/keys/$namespaceId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: z.object({
    prefix: z.string().optional(),
    cursor: z.string().optional()
  }).optional()
});